/* Affiorezuna product page extras. Load after af-product.js.
   - Delivery card: highlights the estimated arrival date.
   - Date check: compares the typed date with the delivery estimate.
   - Saved progress: remembers the customer's choices for 30 days,
     so a returning visitor finds everything filled in. */
(function () {
  'use strict';
  var DAY = 864e5;

  function parseDate(v) {
    v = String(v || '').trim();
    if (!v) return null;
    var m = v.match(/^(\d{1,2})[.\/\-\s](\d{1,2})[.\/\-\s](\d{2,4})$/);
    var d;
    if (m) {
      var y = +m[3];
      if (y < 100) y += 2000;
      d = new Date(y, +m[1] - 1, +m[2]);
      if (d.getMonth() !== +m[1] - 1) return null;
    } else if ((m = v.match(/^(\d{4})[.\/\-](\d{1,2})[.\/\-](\d{1,2})$/))) {
      d = new Date(+m[1], +m[2] - 1, +m[3]);
    } else {
      var t = Date.parse(v.replace(/(\d)(st|nd|rd|th)\b/gi, '$1'));
      if (isNaN(t)) return null;
      d = new Date(t);
    }
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }

  function init(root) {
    if (root.__afExtras) return;
    root.__afExtras = true;
    function $(s) { return root.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

    var form = $('form');
    var names = $('[data-names]');
    var date = $('[data-date]');
    var font = $('[data-font-select]');
    var notes = $('[data-notes]');
    var note = $('[data-card-note]');
    var qty = $('[data-qty-input]');
    var tierSel = $('[data-tier-select]');
    var check = $('[data-date-check]');
    var key = 'af-pdp-' + (root.getAttribute('data-product-id') || location.pathname);

    /* ---------- date is optional ----------
       The section markup still marks the date as required; relax it here
       and label it the same way as the optional font field. */
    if (date) {
      date.required = false;
      var dateLabel = root.querySelector('label[for="' + date.id + '"]');
      if (dateLabel && !dateLabel.querySelector('.af-field__opt')) {
        dateLabel.insertAdjacentHTML('beforeend', ' <span class="af-field__opt">(optional)</span>');
      }
    }

    /* ---------- delivery card ----------
       Turns the first promise line into a highlighted estimate
       with the arrival date set large. */
    function deliveryCard() {
      var top = $('[data-eta-top]');
      var arrive = root.getAttribute('data-af-arrive');
      var li = top && top.closest('li');
      if (!li || !arrive) return;
      var box = document.createElement('div');
      box.className = 'af-eta-card__text';
      box.innerHTML = '<span class="af-eta-card__label">Estimated delivery</span><strong class="af-eta-card__date"></strong>';
      box.children[1].textContent = new Date(arrive).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
      top.parentNode.replaceChild(box, top);
      li.classList.add('af-eta-card');
    }
    deliveryCard();

    /* ---------- date check ---------- */
    function dateCheck() {
      if (!check || !date) return;
      var w = parseDate(date.value);
      var arrive = root.getAttribute('data-af-arrive');
      var ship = root.getAttribute('data-af-ship');
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (!w || !arrive || w < today || w - today > 730 * DAY) { check.hidden = true; return; }
      var a = new Date(arrive);
      a.setHours(0, 0, 0, 0);
      var days = Math.round((w - a) / DAY);
      var express = new Date(ship);
      var state;
      var text;
      if (days >= 3) {
        state = 'ok';
        text = '\u2713 Arrives around ' + fmt(a) + ', ' + (days >= 14 ? Math.floor(days / 7) + ' weeks' : days + ' days') + ' before your date.';
      } else if (express <= w) {
        state = 'warn';
        text = 'Tight timing. Message us before ordering and we can rush your favors to arrive in about 4 business days.';
      } else {
        state = 'bad';
        text = 'This is very close to your date. Please message us before ordering so we can help.';
      }
      check.className = 'af-date-check is-' + state;
      check.textContent = text;
      check.hidden = false;
    }

    /* ---------- saved progress ---------- */
    function read() {
      try {
        var d = JSON.parse(localStorage.getItem(key) || 'null');
        return d && Date.now() - d.t < 30 * DAY ? d : null;
      } catch (e) { return null; }
    }
    function save() {
      try {
        var design = $('[data-design][aria-pressed="true"]');
        var pack = $$('[data-pack]').filter(function (p) { return p.checked; })[0];
        var tier = $$('[data-tier]').filter(function (p) { return p.checked; })[0];
        localStorage.setItem(key, JSON.stringify({
          t: Date.now(),
          design: design && design.getAttribute('data-name'),
          pack: pack && pack.value,
          qty: qty && qty.value,
          pcs: tier ? tier.value : (tierSel && tierSel.value),
          names: names && names.value,
          date: date && date.value,
          font: font && font.value,
          notes: notes && notes.value,
          note: note && !note.disabled ? note.value : ''
        }));
      } catch (e) {}
    }
    var timer;
    function later() { clearTimeout(timer); timer = setTimeout(save, 300); }

    function restore(d) {
      if (d.design) {
        var b = $$('[data-design]').filter(function (x) { return x.getAttribute('data-name') === d.design; })[0];
        if (b) {
          var li = b.closest('li');
          if (li && li.classList.contains('is-extra')) { var list = $('[data-designs]'); if (list) list.classList.add('is-open'); }
          b.click();
        }
      }
      if (d.pack) {
        var p = $$('[data-pack]').filter(function (x) { return x.value === d.pack; })[0];
        if (p) { p.checked = true; fire(p, 'change'); }
      }
      if (qty && d.qty) { qty.value = d.qty; fire(qty, 'input'); }
      if (d.pcs) {
        var t = $$('[data-tier]').filter(function (x) { return x.value === d.pcs; })[0];
        if (t) { t.checked = true; fire(t, 'change'); }
        else if (tierSel) { tierSel.value = d.pcs; fire(tierSel, 'change'); }
      }
      [[names, d.names], [date, d.date], [notes, d.notes]].forEach(function (pair) {
        if (pair[0] && pair[1]) { pair[0].value = pair[1]; fire(pair[0], 'input'); }
      });
      if (font && d.font) { font.value = d.font; fire(font, 'change'); }
      if (note && !note.disabled && d.note) { note.value = d.note; fire(note, 'input'); }
    }

    var saved = read();
    if (saved) restore(saved);

    root.addEventListener('input', later);
    root.addEventListener('change', later);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-design], [data-preset]')) later(); });
    if (form) form.addEventListener('submit', function () {
      if (form.checkValidity()) { try { localStorage.removeItem(key); } catch (e) {} }
    });

    if (date) date.addEventListener('input', dateCheck);
    dateCheck();
  }

  function boot() { document.querySelectorAll('[data-af-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
